import clsx from 'clsx'

import styled from 'styled-components'

export type SpinnerProps = {
  className?: string
  borderSize?: string
  size?: string
  color?: string
  bg?: string
}

const Spin = styled.div<Omit<SpinnerProps, 'className'>>`
  border-style: solid;
  border-width: ${(props) => (props.borderSize ? props.borderSize : 'var(--spacer-2)')};
  border-color: ${(props) => (props.bg ? props.bg : 'transparent')};
  border-left-color: ${(props) => (props.color ? props.color : 'var(--gray-900)')};
  border-radius: 50%;
  width: ${(props) => (props.size ? props.size : '6.25rem')};
  height: ${(props) => (props.size ? props.size : '6.25rem')};
  animation: spin-animation 1s linear infinite;

  @keyframes spin-animation {
    to {
      transform: rotate(360deg);
    }
  }
`

const Spinner = ({ className, ...rest }: SpinnerProps) => {
  return (
    <div
      data-test='infinity-spinner'
      className={clsx('_d-flex _justify-content-center', className)}>
      <Spin {...rest} />
    </div>
  )
}

export default Spinner
